<template>
  <div class="section-header">
    <p class="section-title">{{ title }}</p>
    <v-btn
      v-if="isToggleable"
      icon
      variant="tonal"
      size="x-small"
      color="primary"
      class="section-action"
      @click="$emit('toggle')"
    >
      <v-icon size="24">
        {{ expanded ? "mdi-chevron-up" : "mdi-chevron-down" }}
      </v-icon>
    </v-btn>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    title: string;
    expanded?: boolean | null;
  }>(),
  {
    expanded: null,
  }
);

defineEmits<{
  (event: "toggle"): void;
}>();

const isToggleable = computed(() => props.expanded !== null);
</script>

<style scoped>
.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.section-title {
  margin: 0;
  font-size: 14px;
  text-transform: uppercase;
  color: var(--color-theme);
  font-weight: 600;
  letter-spacing: 2px;
}

.section-action {
  background: #f8fafc;
}
</style>
